<div nz-row nzGutter="25">
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div
      class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative h-full">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Progress bar</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-progress-line></nz-demo-progress-line>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div
      class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative h-full">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Circular progress bar</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-progress-circle></nz-demo-progress-circle>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div
      class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative h-full">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Mini size progress bar</h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-progress-line-mini></nz-demo-progress-line-mini>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div
      class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative h-full">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Mini size circular progress bar
        </h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-progress-circle-mini></nz-demo-progress-circle-mini>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div
      class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative h-full">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Dynamic circular progress bar
        </h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-progress-circle-dynamic></nz-demo-progress-circle-dynamic>
      </div>
    </div>
  </div>
  <div nz-col nzXs="24" nzLg="12" class="mb-[25px]">
    <div
      class="bg-white dark:bg-white/10 m-0 p-0 text-theme-gray dark:text-white/60 text-[15px] rounded-10 relative h-full">
      <div class="py-[16px] px-[25px] text-dark dark:text-white/[.87] font-medium text-[17px]">
        <h4 class="mb-0 text-lg font-medium text-dark dark:text-white/[.87] capitalize">Custom text format
        </h4>
      </div>
      <div class="p-[25px] pt-0">
        <nz-demo-progress-format></nz-demo-progress-format>
      </div>
    </div>
  </div>
</div>
